export default "__VITE_ASSET__DMitGBjM__"